import { Stack, Typography, useMediaQuery } from '@mui/material'
import { FunctionComponent } from 'react'
import gaiaTheme from '../../../root-components/theme';
import { IColorPalatte } from '../shared-services/public-reports.model';
import { usePdfExportMode } from '../../../hooks/use-pdf-export-mode';
import { GAIA_PDF_PAGE_HEIGHT_PX, getGaiaReportBodyTextSx, getGaiaReportSectionShellSx } from './gaia-report-web-page-pdf-styles';
import { useReportContentOverride } from '../shared-services/gaia-report-content';

export const GaiaReportWebPageExecSummary: FunctionComponent<{
  companyName: string,
  reportPeriodCalendarYear: string,
  reportPeriodYear: string,
  colorPalatte: IColorPalatte,
  partnerName: string | null,
}> = ({
  companyName, reportPeriodCalendarYear, reportPeriodYear, colorPalatte, partnerName }) => {

    const isMobileModeMd = useMediaQuery(gaiaTheme.breakpoints.down('md'));
    const isMobileModeSm = useMediaQuery(gaiaTheme.breakpoints.down('sm'));
    const pdfExport = usePdfExportMode();

    const heading = useReportContentOverride('executiveSummary.heading');
    const body1 = useReportContentOverride('executiveSummary.body1');
    const body2 = useReportContentOverride('executiveSummary.body2');

    return (
      <Stack sx={{
        ...getGaiaReportSectionShellSx({
          backgroundColor: colorPalatte.dark,
          pdfExport,
          webBottomPadding: 12,
          webBorderRadius: '0',
          overflow: 'hidden',
        }),
        minHeight: pdfExport ? `${GAIA_PDF_PAGE_HEIGHT_PX}px` : '100vh',
        boxSizing: 'border-box',
        width: '100%',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }}>
        <Stack sx={{
          width: '100%',
          maxWidth: isMobileModeSm ? '100%' : isMobileModeMd ? '72%' : '58%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          pt: pdfExport ? 8 : 6,
          pb: pdfExport ? 4 : 0,
        }}>
          <Typography variant='h3' sx={{ color: 'white', mb: 6, textAlign: 'center' }}>{heading ?? 'Executive Summary'}</Typography>
          <Stack>
            <Typography sx={{ ...getGaiaReportBodyTextSx({ color: 'white', isMobileModeMd, isMobileModeSm, pdfExport, pdfMarginBottom: 4, webMarginBottom: 4 }), textAlign: 'center' }}>
              {body1 ?? `This Greenhouse Gas Emissions (GHG) Report provides a comprehensive analysis of ${companyName}'s carbon footprint for the ${reportPeriodYear} ${reportPeriodCalendarYear}, covering Scope 1, Scope 2 and Scope 3 emissions. The report is aligned with the GHG Protocol using the data from the ${partnerName ? partnerName : 'Gaia'} Carbon Accounting emissions assessment.`}
            </Typography>
            <Typography sx={{ ...getGaiaReportBodyTextSx({ color: 'white', isMobileModeMd, isMobileModeSm, pdfExport, pdfMarginBottom: 0, webMarginBottom: 0 }), textAlign: 'center' }}>{body2 ?? 'The primary objective of this report is to quantify and analyse the GHG emissions across all operational boundaries, indentify key emission sources, and assess progress towards our sustainability goals. The report covers emissions from all facilities, operations, and supply chain activities within our global footprint, providing a clear picture of our environmental impact.'}</Typography>
          </Stack>
        </Stack>
      </Stack>
    )
  }